import { isNil } from '@lucidlink/tscore';
import { IncrementCounterRequest } from './messages/increment-counter';
export class AtomicCounterProxy {
    client;
    serverSession;
    atomicCounterServiceDestinationPath;
    constructor(fsId, client, serverSession) {
        this.client = client;
        this.serverSession = serverSession;
        this.atomicCounterServiceDestinationPath = `/${fsId}/AtomicCounter`;
    }
    async fetchNodeIndex() {
        const req = new IncrementCounterRequest('NodeIndex', 1, this.atomicCounterServiceDestinationPath);
        const result = (await this.sendRequest(req)).result;
        return Number(result);
    }
    async sendRequest(msg) {
        const sessionToken = isNil(this.serverSession) ? undefined : await this.serverSession.getSessionToken();
        return (await this.client.sendRequest(msg, sessionToken));
    }
}
